<template>
  <el-dialog
    title="站点地图"
    :visible.sync="dialogVisible"
    width="90%"
    :before-close="handleClose"
    class="station-map-dialog"
  >
    <div class="map-dialog-content" v-loading="loading">
      <!-- 有位置信息时显示地图 -->
      <div class="location-card" v-if="stationInfo.lat > 0">
        <div class="location-header">
          <div class="location-icon">
            <i class="el-icon-location" style="font-size: 32px; color: #2979ff;"></i>
          </div>
          <div class="location-title">{{ stationInfo.name || stationData.name || stationData.tit }}</div>
        </div>
        
        <div class="map-container">
          <iframe 
            :src="mapUrl" 
            frameborder="0" 
            class="map-frame" 
            scrolling="no"
          ></iframe>
        </div>
      
      </div>

      <!-- 无位置信息时显示空状态 -->
      <div v-else class="empty-state">
        <div class="empty-card">
          <div class="icon-wrapper">
            <i class="el-icon-location" style="font-size: 64px; color: #ccc;"></i>
          </div>
          <div class="empty-title">暂无位置信息</div>
          <div class="empty-subtitle">位置信息暂未收录</div>
        </div>
      </div>

      <!-- 位置信息 -->
      <div class="info-section" v-if="stationInfo.name_full">
        <div class="section-title">地址信息</div>
        <div class="info-content">{{ stationInfo.name_full }}</div>
      </div>

      <div class="info-section" v-if="stationInfo.info">
        <div class="section-title">位置引导</div>
        <div class="info-content" v-html="stationInfo.info"></div>
      </div>
      <div class="info-section" v-if="stationInfo.cn">
        <div class="section-title">位置引导</div>
        <div class="info-content" v-html="stationInfo.cn"></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StationMapDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    stationData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      stationInfo: {
        id: 0,
        name: '',
        lat: 0,
        lng: 0,
        address: '',
        info: ''
      },
      mapUrl: ''
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.loadStationInfo()
      }
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    // 加载站点信息
    async loadStationInfo() {
      console.log('loadStationInfo called, stationData:', this.stationData)
      
      if (!this.stationData || !this.stationData.source) {
        console.log('缺少站点数据或source字段')
        this.$message.warning('缺少站点数据')
        return
      }

      this.loading = true
      try {
        let params = {}
        
        if (this.stationData.source === 'bushikaku') {
          // bushikaku数据源，直接使用传入的对象
          params = {
            id: this.stationData.id,
            name: this.stationData.name,
            key: this.stationData.key,
            source: this.stationData.source
          }
        } else {
          // 其他数据源，使用key和source
          params = {
            source: this.stationData.source,
            key: this.stationData.key,
            name: this.stationData.name || this.stationData.tit
          }
        }
        
        console.log('发送AJAX请求，参数:', params)
        let response = await axios.post(this.base_url + '/v4/point_v2', params)
        console.log('AJAX响应:', response.data)
        response = response.data
        if (response.data && response.data.info) {
          this.stationInfo = response.data.info
          this.mapUrl = response.data.map || ''
          this.generateMapUrl()
          console.log('站点信息加载成功:', this.stationInfo)
        } else {
          console.log('响应中没有找到站点信息')
          this.$message.warning('未找到站点信息')
        }
      } catch (error) {
        console.error('加载站点信息失败:', error)
        this.$message.error('加载站点信息失败')
      } finally {
        this.loading = false
      }
    },

    // 生成地图URL
    generateMapUrl() {
      // if (this.stationInfo.lat && this.stationInfo.lng) {
      //   this.mapUrl = `https://www.google.com/maps/embed/v1/place?key=YOUR_API_KEY&q=${this.stationInfo.lat},${this.stationInfo.lng}`
      // }
    },

 
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.station-map-dialog {
  .map-dialog-content {
    max-height: 70vh;
    overflow-y: auto;
  }

  .location-card {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
  }

  .location-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    
    .location-icon {
      margin-right: 12px;
    }
    
    .location-title {
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
    }
  }

  .map-container {
    width: 100%;
    height: 500px;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 16px;
    
    .map-frame {
      width: 100%;
      height: 100%;
      border: none;
    }
  }

  .action-buttons {
    display: flex;
    gap: 12px;
    justify-content: center;
  }

  .empty-state {
    text-align: center;
    padding: 40px 20px;
    
    .empty-card {
      .icon-wrapper {
        margin-bottom: 16px;
      }
      
      .empty-title {
        font-size: 18px;
        font-weight: 600;
        color: #606266;
        margin-bottom: 8px;
      }
      
      .empty-subtitle {
        font-size: 14px;
        color: #909399;
      }
    }
  }

  .info-section {
    margin-top: 20px;
    padding: 16px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #ebeef5;
    
    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: #2c3e50;
      margin-bottom: 12px;
      padding-bottom: 8px;
      border-bottom: 1px solid #ebeef5;
    }
    
    .info-content {
      font-size: 14px;
      line-height: 1.6;
      color: #606266;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .station-map-dialog {
    .action-buttons {
      flex-direction: column;
      
      .el-button {
        width: 100%;
      }
    }
    
    .map-container {
      height: 250px;
    }
  }
}
 
</style>